<template>
  <div class="newUisetting">
    <el-card style="height: 99%;" class="box-card">
      <div slot="header" class="clearfix">
        <span class="font-sz20">相关文件管理</span>
        <div class="head-text">
          <el-input placeholder="请输入内容" suffix-icon="el-input__icon el-icon-search" v-model="searchword"
            style="width:240px;margin-right: 15px;" @input="
              pageIndex = 1;
            GetYWProTechnologyList_WJ(addtype);
            ">
          </el-input>
          <el-button type="primary" @click="opentechnologyfile">技术措施一览表管理</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <div style="float: right;margin-bottom: 15px;">
          <el-button type="primary" @click="addfile()">新增</el-button>
          <el-button type="primary" @click="updataBtn">{{
            updateState ? "关闭重命名" : "重命名"
          }}</el-button>
          <el-button type="primary" @click="exportExcel">下载</el-button>
          <el-button type="danger" @click="dellot">删除</el-button>
        </div>
        <el-tab-pane label="规范文件" name="first">
          <el-table :data="tableData1" ref="multipleTable" class="table" height="530"
            style="width: 100%;margin-top: 15px;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" label="序号" width="150" align="center"></el-table-column>
            <el-table-column prop="fname" sortable min-width="60" show-overflow-tooltip label="文件名称" align="center">
              <template slot-scope="scope">
                <el-input v-if="updateState == true" size="medium" placeholder="输入内容" v-model="scope.row.fname"
                  @change="changeGdposValue(scope.row)" />
                <el-button v-else size="small" type="text" @click="lookImage(scope.row.fpath)">{{ scope.row.fname
                  }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="user04" label="更新人" align="center">
            </el-table-column>
            <!-- <el-table-column prop="createtime" label="更新时间" align="center">
            </el-table-column> -->
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="管理文件" name="second">
          <el-table :data="tableData2" height="530" ref="multipleTable" style="width: 100%;margin-top: 15px;"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" label="序号" width="150" align="center"></el-table-column>
            <el-table-column prop="fname" sortable label="文件名称" align="center" min-width="60" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-input v-if="updateState == true" size="medium" placeholder="输入内容" v-model="scope.row.fname"
                  @change="changeGdposValue(scope.row)" />
                <el-button v-else size="small" type="text" @click="lookImage(scope.row.fpath)">{{ scope.row.fname
                  }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="user04" label="更新人" align="center">
            </el-table-column>
            <el-table-column prop="createtime" label="更新时间" align="center">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="评审文件" name="third">
          <el-table :data="tableData3" height="530" ref="multipleTable" style="width: 100%;margin-top: 15px;"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" label="序号" width="150" align="center"></el-table-column>
            <el-table-column prop="fname" sortable label="文件名称" align="center" min-width="60" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-input v-if="updateState == true" size="medium" placeholder="输入内容" v-model="scope.row.fname"
                  @change="changeGdposValue(scope.row)" />
                <el-button v-else size="small" type="text" @click="lookImage(scope.row.fpath)">{{ scope.row.fname
                  }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="user04" label="更新人" align="center">
            </el-table-column>
            <el-table-column prop="createtime" label="更新时间" align="center">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <div style="
      margin-top: 15px;
              display: flex;
              align-items: right;
              justify-content: space-around;
            ">
          <el-pagination @size-change="handleSizeChange" @current-change="CurrentChange" :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total" background>
          </el-pagination>
        </div>
      </el-tabs>
      <el-dialog title="新增" width="40%" :close-on-click-modal="false" v-loading="UploadLoading"
        :visible.sync="addfilemanagement">
        <el-divider />
        <el-upload class="upload-demo" accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :action="actionUrl"
          :file-list="fileList" :on-change="handleChange" :before-upload="beforeUpload" multiple>
          <el-button size="medium">点击上传</el-button>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addfilemanagement = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确定上传</el-button>
        </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="超低能耗技术措施一览表" :visible.sync="technologyfile" width="80%"
        height="50%" :before-close="handleClose">
        <el-divider />
        <div>
          <el-button type="primary" size="medium" @click="addfile(1)" style="float: right;">单击替换</el-button>
          <iframe v-if="filesrc" style="margin-top: 15px;" :height="ModelHeight" width="100%"
            :src="filesrc + '#scrollbars=0&toolbar=0&statusbar=0&view=FitH,top'"></iframe>
          <iframe v-else style="margin-top: 15px;" :height="ModelHeight" width="100%" :src="filesrc"></iframe>
        </div>
      </el-dialog>
      <LookIframe ref="iframebaseRef"></LookIframe>
    </el-card>
  </div>
</template>
<script>
import {
  GetYWProTechnologyList,
  AddOrUpdateYwProTechnology,
  DelYWProTechnology,
  OfficeOnline,
} from "@/setAxios.js";
import LookIframe from "@/components/LookIframe.vue";
import { download, downloadMore } from "@/tools/tool";
export default {
  name: "filemanagement",
  components: { LookIframe },
  data() {
    return {
      tableData1: [],
      tableData2: [],
      tableData3: [],
      pageIndex: 1,
      pageSize: 10,
      total: 15,
      multipleSelection: [],
      searchword: "",
      addfilemanagement: false,
      updateState: false,
      activeName: "first",
      addtype: 2,
      fileList: [],
      actionUrl: this.$store.state.baseUrl,
      technologyfile: false,
      filesrc: "",
      ModelHeight: document.body.clientHeight - 90,
      id: null,
      UploadLoading: false,
      updataInfo: {
      }
    };
  },
  methods: {
    handleClick(tab) {
      switch (tab.index) {
        case "0":
          this.addtype = 2;
          this.GetYWProTechnologyList_WJ(2);
          this.updateState = false;
          this.searchword = "";
          break;
        case "1":
          this.addtype = 3;
          this.GetYWProTechnologyList_WJ(3);
          this.updateState = false;
          this.searchword = "";
          break;
        case "2":
          this.addtype = 4;
          this.GetYWProTechnologyList_WJ(4);
          this.updateState = false;
          this.searchword = "";
          break;
        default:
          break;
      }
    },
    GetYWProTechnologyList_WJ(types, size) {
      GetYWProTechnologyList({
        params: {
          xid: this.$store.state.xid,
          type: types,
          searchword: this.searchword,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        switch (types) {
          case 1:
            this.id = res.Data.list[0].id;
            let filePaths = res.Data.list[0].fpath;
            this.updataInfo = res.Data.list[0]
            var suffix = filePaths.substring(filePaths.lastIndexOf(".") + 1);
            if (
              suffix == "pdf" ||
              suffix == "png" ||
              suffix == "jpg" ||
              suffix == "gif" ||
              suffix == "txt"
            ) {
              this.filesrc = this.$store.state.baseUrl + res.Data.list[0].fpath;
            } else {
              let params = {
                sourcePath: filePaths,
                type: "html",
              };
              let fd = new FormData();
              for (var key in params) {
                fd.append(key, params[key]);
              }
              OfficeOnline(fd).then((res) => {
                if (res.Code == 0) {
                  this.$message.error(res.Message);
                } else {
                  this.filesrc = this.$store.state.baseUrl + res.Data;
                }
              });
            }
            break;
          case 2:
            this.tableData1 = res.Data.list;
            this.total = res.Data.total;
            break;
          case 3:
            this.tableData2 = res.Data.list;
            this.total = res.Data.total;
            break;
          case 4:
            this.tableData3 = res.Data.list;
            this.total = res.Data.total;
            break;
          default:
            break;
        }
      });
    },
    updataBtn() {
      this.updateState = !this.updateState;
      this.updateState == false
        ? this.GetYWProTechnologyList_WJ(this.addtype)
        : "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetYWProTechnologyList_WJ(this.addtype);
    },
    CurrentChange(val) {
      this.pageIndex = val;
      this.GetYWProTechnologyList_WJ(this.addtype);
    },
    lookImage(data) {
      this.$refs.iframebaseRef.LookItemPics(data);
    },
    changeGdposValue(value) {
      this.Updategdproschedule(value);
    },
    opentechnologyfile() {
      this.technologyfile = true;
      this.pageIndex = 1;
      this.GetYWProTechnologyList_WJ(1);
    },
    handleClose() {
      this.technologyfile = false;
      this.id = 0;
      this.activeName == "first" ? this.addtype = 2 : "";
      this.activeName == "second" ? this.addtype = 3 : "";
      this.activeName == "third" ? this.addtype = 4 : "";
    },
    Updategdproschedule(row) {
      let fd = new FormData();
      fd.append("files", "");
      for (var key in row) {
        fd.append(key, row[key]);
      }
      AddOrUpdateYwProTechnology(fd).then((res) => {
        if (res.Code > 0) {
          this.$message.success("修改成功");
        } else {
          this.$message.error("修改失败");
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    dellot() {
      if (this.multipleSelection.length < 1) {
        this.$message.warning("请选择需要删除的数据");
        return false;
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var Selection = [];
          this.multipleSelection.forEach((item, index) => {
            Selection.push(item.id);
          });
          DelYWProTechnology({ ids: Selection.join(",") }).then((res) => {
            this.$message.success("删除成功");
            this.GetYWProTechnologyList_WJ(this.addtype);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    beforeUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      var suffixs = ["doc", "docx", "pdf", "ppt", "pptx", "xls", "xlsx"];
      if (suffixs.indexOf(suffix) == -1) {
        this.$message({
          message: "上传文件只能是 word、excel、ppt、pdf格式!",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    addfile(type) {
      type == 1 ? (this.addtype = 1) : this.addtype;
      this.fileList = [];
      this.addfilemanagement = true;
    },
    onSubmit() {
      if (this.fileList.length < 1) {
        this.$message.warning("请选择需要上传的文件");
        return false;
      }
      this.UploadLoading = true;
      let fd = new FormData();
      this.fileList.forEach((file) => {
        fd.append("files", file.raw);
      });
      fd.append("id", this.id == null ? 0 : this.id);
      fd.append("projectid", this.$store.state.xid);
      fd.append("type", this.addtype);
      fd.append("createuserid", localStorage.getItem("id"));
      fd.append("fname", this.updataInfo.fname);
      fd.append("fpath", this.updataInfo.fpath);
      AddOrUpdateYwProTechnology(fd).then((res) => {
        if (res.Code == 1) {
          this.$message.success("上传成功");
          this.fileList = [];
          this.addfilemanagement = false;
          this.GetYWProTechnologyList_WJ(this.addtype);
        } else {
          this.$message.error(res.Message);
        }
        this.UploadLoading = false;
      });
    },
    // 下载
    exportExcel() {
      if (this.multipleSelection.length < 1) {
        this.$message.warning("请选择要下载的内容");
      } else {
        this.multipleSelection.forEach((el) => {
          this.downLoad(el.fpath, el.fname);
        });
      }
    },
    downLoad(path, name) {
      try {
        download(
          this.$store.state.baseUrl + path,
          name + path.substr(path.lastIndexOf("."))
        );
      } catch (error) {
        this.$message.error("下载失败");
      }
    },
  },
  created() {
    this.GetYWProTechnologyList_WJ(2);
  },
};
</script>
<style lang="scss" scoped>
.font-sz20 {
  font-size: 20px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.el-dialog__body,
.home {
  min-height: 500px;
}

.el-divider {
  margin-top: -25px;
}
</style>
